import { writable, derived, get } from 'svelte/store';

export const Endpoint = 'https://jj11izrm8e.execute-api.eu-central-1.amazonaws.com/'
export const step = writable(1)
export const user = writable({})
export const tos = writable(false)
export const Errors = writable({})

export const userPost = derived(
	user,
	$user => {
		return {
			token: $user.token.toUpperCase(),
			company: {
				email: $user.email,
				first_name: $user.first_name,
				last_name: $user.last_name,
				language: 'en',
			}
		}
	}
)

export const setUserFromURL = () => {
	let searchParams = new URLSearchParams(window.location.search)
	user.set({
		token: searchParams.has('token') ? searchParams.get('token') : '',
		first_name: searchParams.has('first_name') ? searchParams.get('first_name') : '',
		last_name: searchParams.has('last_name') ? searchParams.get('last_name') : '',
		email: searchParams.has('email') ? searchParams.get('email') : '',
	})
}

export const Token = derived(
	user,
	$user => $user.token
)

export const TokenLoading = writable(false)
export const TokenStatus = writable('')
export const TokenValid = writable(false)

export const TokenError = (response) => {
	Errors.set(transformErrorMessages({token: response.token}))
	TokenValid.set(false)
}

export const TokenSuccess = (response) => {
	Errors.set({})
	TokenValid.set(true)
}

export const checkToken = () => {
	TokenLoading.set(true)
}
export const checkTokenComplete = () => {
	TokenLoading.set(false)
}

export const setTokenStatus = (status) => {
	TokenStatus.set(status);
	TokenLoading.set(false)
}

export const UserLoading = writable(false)
export const UserValid = writable(false)

export const UserError = (status) => {
	Errors.set(transformErrorMessages({ user: status }))
	UserValid.set(false)
}

export const UserSuccess = () => {
	Errors.set({})
	UserValid.set(true)
}

export const checkUser = () => {
	UserLoading.set(true)
}

export const checkUserComplete = () => {
	UserLoading.set(false)
}

export const setValidationErrors = (validation_errors) => {
	Errors.set(transformErrorMessages(validation_errors))
} 

function transformErrorMessages(errorObject){
	for (const [key, value] of Object.entries(errorObject) ){
		switch (value) {
			case 'cannot be blank':
				errorObject[key] = 'This field is required'
				break;
			case 'must be a valid email address':
				errorObject[key] = 'Please use a valid email address'
				break;
			case 'Already exists':
				errorObject[key] = 'An account with this email already exists.'
				break;
			case 'invalid':
				errorObject[key] = 'This token is invalid, please try again.'
				break;
			case 'used':
				errorObject[key] = 'This token has already been used.'
				break;
			default:
				errorObject[key] = 'Please check this field again'
		}
	}
	return errorObject
}
